module.exports = __webpack_public_path__ + "img/wfpa-logo.8dbd274a.png";